import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { LEDGER_QUERY_KEY } from "./constants";
import { buildLedgerQuery, type LedgerFilters } from "./ledger-filters";
import type { LedgerPageResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/ledger`
 * (API-FIN-5) is the append-only cash ledger, read tier ADMIN + FINANCE.
 * Also the VENUE_TRANSFER payment-history view when filtered by venue + type.
 */
export function useLedger(filters: LedgerFilters) {
  return useQuery({
    queryKey: [
      ...LEDGER_QUERY_KEY,
      filters.entryType ?? "all",
      filters.venueId.trim(),
      filters.currency.trim().toLowerCase(),
      filters.from,
      filters.to,
      filters.page,
    ] as const,
    queryFn: () => httpClient<LedgerPageResponse>(`/api/admin/ledger${buildLedgerQuery(filters)}`),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
